export const SUPER_ADMIN = [
  {url: '/companies?tabs=all', name: 'Уровни и доступы'},
  {url: '/super-admins?tabs=all', name: 'Администраторы'},
  // {url: '/specialties', name: 'Специальности'},
]

export const ADMIN = [
  {url: '/applications', name: 'Заявки'},
  {url: '/vacancies?tabs=open', name: 'Вакансии'},
  {url: '/responses?tabs=unprocessed', name: 'Отклики'},
  {url: '/analytics?tabs=by-vacancies', name: 'Аналитика'},
  {url: '/candidates?tabs=all', name: 'База кандидатов'},
  {url: '/templates', name: 'Шаблоны'},
]

export const ADMIN_SETTINGS = [
  {url: '/divisions', name: 'Подразделения'},
  {url: '/employees/?tabs=all', name: 'Права доступа'},
  {url: '/legal-entities', name: 'Юридические лица'},
  {url: '/positions', name: 'Должности'},
  {url: '/sources', name: 'Источники'},
  {url: '/settings', name: 'Настройка сроков'},
  {url: '/settings?reasons=true', name: 'Причины отказа'},
  {url: '/account-integrations', name: 'Интеграции аккаунтов'},

]

export const HR = [
  {url: '/applications', name: 'Заявки'},
  {url: '/vacancies?tabs=open', name: 'Вакансии'},
  {url: '/responses?tabs=unprocessed', name: 'Отклики'},
  {url: '/analytics?tabs=by-vacancies', name: 'Аналитика'},
  {url: '/candidates?tabs=all', name: 'База кандидатов'},
  {url: '/templates', name: 'Шаблоны'},
]

export const APPROVING_PERSON = [
  {url: '/responses?tabs=unprocessed', name: 'Отклики'},
  {url: '/applications', name: 'Заявки'},
]

export const SECURITY_SERVICE = [
  {url: '/sb-tasks', name: 'Отклики'},
]

export const HR2 = [
  {url: '', name: ''},
  {url: '', name: ''},
  {url: '', name: ''},
  {url: '', name: ''},
  {url: '', name: ''},
  {url: '', name: ''},
]